export const formStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
};

export const summaryStyles = {
  display: 'grid',
  gridTemplateColumns: '100px 1fr',
  rowGap: '8px',
  columnGap: '16px',
  alignItems: 'baseline',
};

export const sectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const loaderStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: '16px',
};

export const footerStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  paddingTop: '16px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const footerButtonsStyles = {
  display: 'flex',
  gap: '12px',
};

export const historyTitleStyles = {
  textTransform: 'uppercase',
};
